<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && resource">
			<div class="col-sm-12">
				<div class="row">
					<!-- consultant -->
					<div class="form-group col-md-4">
						<label for="consultant">{{ 'labels.consultant' | translate }}*</label>
						<input
							name="consultant"
							[placeholder]="selected.consultant?.name"
							required
							type="text"
							class="form-control"
							id="companyinput"
							disabled>
					</div>
					<!-- fname -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.fname' | translate }}*</label>
						<input
							[(ngModel)]="resource.fname"
							#fname="ngModel"
							name="fname"
							required
							type="text"
							class="form-control"
							id="fname"
							placeholder="{{ 'labels.fname' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && fname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && fname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- lname -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.lname' | translate }}*</label>
						<input
							[(ngModel)]="resource.lname"
							#lname="ngModel"
							name="lname"
							required
							type="text"
							class="form-control"
							id="lname"
							placeholder="{{ 'labels.lname' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && lname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && lname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- cf -->
					<div class="form-group col-md-4">
						<label for="cf">{{ 'labels.cf' | translate }}*</label>
						<input
							[(ngModel)]="resource.cf"
							#cf="ngModel"
							name="cf"
							required
							type="text"
							class="form-control"
							id="cf"
							pattern="^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$"
							placeholder="{{ 'labels.cf' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && cf.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && cf.invalid">
							{{'errors.invalid' | translate}}
						</div>
					</div>
					<!-- contract -->
					<div class="form-group col-md-4">
						<label>{{'labels.contract' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="resource.contract"
							required
							#contract="ngModel"
							name="contract"
							[ngClass]="{'is-invalid': editForm.submitted && contract.invalid}">
							<option
								*ngFor="let contract of contracttypes"
								[value]="contract.itemvalue">
								{{contract.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && contract.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- contractlevel -->
					<div class="form-group col-md-4">
						<label>{{'labels.contractlevel' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="resource.contractlevel"
							required
							#contractlevel="ngModel"
							name="contractlevel"
							[ngClass]="{'is-invalid': editForm.submitted && contractlevel.invalid}">
							<option
								*ngFor="let contract of contractlevels"
								[value]="contract.itemvalue">
								{{contract.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && contractlevel.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- basehourlysalary -->
					<div class="form-group col-md-4">
						<label>
							{{'labels.basehourlysalary' | translate}}*
						</label>
						<input
							type="number"
							class="form-control"
							name="basehourlysalary"
							[(ngModel)]="resource.basehourlysalary"
							required
							#basehourlysalary="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && basehourlysalary.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && basehourlysalary.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- daylyhrs -->
					<div class="form-group col-md-4">
						<label>{{'labels.daylyhrs' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="daylyhrs"
							[(ngModel)]="resource.daylyhrs"
							required
							#daylyhrs="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && daylyhrs.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && daylyhrs.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- resrole -->
					<div class="form-group col-md-4">
						<label>{{'labels.resrole' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="resource.resrole"
							required
							#role="ngModel"
							name="role"
							[ngClass]="{'is-invalid': editForm.submitted && role.invalid}">
							<option
								*ngFor="let rol of roles"
								[value]="rol.itemvalue">
								{{rol.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && contract.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
